export default __webpack_public_path__ + "static/gb-66772c8074160fee4b8815cfa7443343.svg";